export const cesGroupsFeatureKey = ['ces-groups'] as const;
